// extracted by mini-css-extract-plugin
module.exports = {"outer":"dHyY9","heading":"_4SHug","subText":"_3VNnU"};